import V2 from "./v2/downloads";

export default function Entry(props) {
    return <V2 {...props} />;
}
